import React, { useEffect, useState } from 'react';
import './index.css';

const RatingSummary = ({ appId }) => {
    const [userId, setUserId] = useState(null);
    const [averageRating, setAverageRating] = useState(null);
    const [totalRatings, setTotalRatings] = useState(0);
    const [ratingsDistribution, setRatingsDistribution] = useState({
        '5_stars': 0,
        '4_stars': 0,
        '3_stars': 0,
        '2_stars': 0,
        '1_stars': 0
    });
    const apiUrl = process.env.REACT_APP_API_URL
    useEffect(() => {
        const storedUserId = localStorage.getItem('telegram_user_id');
        setUserId(storedUserId);
    }, []);

    const fetchRatings = async () => {
        try {
            const response = await fetch(`${apiUrl}apps/${appId}/ratings/`);
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
            const data = await response.json();

            setRatingsDistribution(data.votes);
            setAverageRating(data.average_rating);
            setTotalRatings(data.total_votes);
        } catch (error) {
            console.error('Error fetching ratings:', error);
        }
    };

    useEffect(() => {
        fetchRatings();
    }, [appId]);

    const submitRating = async (score) => {
        if (!userId) {
            alert('User ID not found. Please log in.');
            return;
        }
    
        try {
            const response = await fetch(`${apiUrl}apps/rate/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: userId,
                    app_id: appId,
                    score: score,
                }),
            });
    
            if (response.ok) {
                fetchRatings(); // Обновляем данные после успешного голосования
            } else {
                const data = await response.json();
                console.error('Error:', data);
            }
        } catch (error) {
            console.error('Error submitting rating:', error);
        }
    };

    const renderRatingRow = (rating, votes) => {
        const percentage = (votes / totalRatings) * 100;

        return (
            <div className="rating-row" key={rating}>
                <span>{rating}</span>
                <div className="rating-bar-container">
                    <div className="rating-bar" style={{ width: `${percentage}%` }}></div>
                </div>
                <span>{votes}</span>
            </div>
        );
    };

    return (
        <div className="rating-summary">
            <div className="rating-header">
                <div className="average-rating">{averageRating !== null ? averageRating.toFixed(1) : 'N/A'}</div>
                <div className="star-rating">
                    {[...Array(5)].map((_, i) => (
                        <span key={i} className={`star ${i < Math.round(averageRating) ? 'filled' : ''}`}>
                            ★
                        </span>
                    ))}
                </div>
                <div className="total-ratings">{totalRatings} отзывов</div>
            </div>
            <div className="rating-distribution">
                {renderRatingRow('5 ★', ratingsDistribution['5_stars'])}
                {renderRatingRow('4 ★', ratingsDistribution['4_stars'])}
                {renderRatingRow('3 ★', ratingsDistribution['3_stars'])}
                {renderRatingRow('2 ★', ratingsDistribution['2_stars'])}
                {renderRatingRow('1 ★', ratingsDistribution['1_stars'])}
            </div>
            <div className="rate-this-app">
                <h3>Оцените это приложение:</h3>
                {[5, 4, 3, 2, 1].map(star => (
                    <span key={star} className="rate-star" onClick={() => submitRating(star)}>
                        {star} ★
                    </span>
                ))}
            </div>
        </div>
    );
};

export default RatingSummary;
